import React, { useState, useEffect } from "react";
import { Divider } from "@mui/material";
import { db, auth } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import {
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import "./Profile.css";

const Profile = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    organizationName: "",
    dob: "",
    email: "",
    location: "",
    phone: "",
    designation: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const user = auth.currentUser;
      if (user) {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setForm(docSnap.data());
        } else {
          alert("No user data found.");
        }
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    const user = auth.currentUser;
    if (!user) return;

    try {
      const docRef = doc(db, "users", user.uid);
      await updateDoc(docRef, {
        ...form,
        updatedAt: new Date().toISOString(),
      });
      alert("Profile updated!");
      setIsEditing(false);
    } catch (error) {
      alert("Error updating profile: " + error.message);
    }
  };

  const handlePasswordChange = async () => {
    const user = auth.currentUser;
    if (!user || !oldPassword || !newPassword) {
      alert("Please fill in both fields.");
      return;
    }

    if (newPassword.length < 6) {
      alert("New password must be at least 6 characters.");
      return;
    }

    const credential = EmailAuthProvider.credential(user.email, oldPassword);

    try {
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      alert("Password updated successfully!");
      setOldPassword("");
      setNewPassword("");
    } catch (error) {
      alert("Failed to update password: " + error.message);
    }
  };

  const handleResetPassword = async () => {
    const user = auth.currentUser;
    if (!user) return;

    try {
      await updatePassword(user, "Tabl@123");
      alert("Password reset to Tabl@123 successfully.");
    } catch (error) {
      alert("Error resetting password: " + error.message);
    }
  };

  return (
   <>
      
   
      <div className="profile-container">
       

        <div className="profile-data">
          <div className="profile-content">
            <h2 className="profile-name">{`${form.firstName} ${form.lastName}`}</h2>
            <p className="role">
              <span className="organization">{form.organizationName}</span> |{" "}
              <span className="designation">{form.designation}</span>
            </p>
          </div>
        </div>

        <div className="profile-body">
          <div className="left-panel">
            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email</label>
                <input name="email" value={form.email} disabled />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Designation</label>
                <input
                  name="designation"
                  value={form.designation || ""}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="dob"
                  value={form.dob}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>
            </div>

            {!isEditing ? (
              <button className="edit-btn" onClick={() => setIsEditing(true)}>
                Edit Details
              </button>
            ) : (
              <button className="edit-btn" onClick={handleUpdate}>
                Save Changes
              </button>
            )}
          </div>

          <div className="right-panel">
            <div className="right-form">
              <div className="form-row">
                <div className="form-group right-group">
                  <label>Email</label>
                  <input disabled value={form.email} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group right-group">
                  <label>Old Password</label>
                  <input
                    type="password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group right-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
              </div>
              <button className="change-pass-btn" onClick={handlePasswordChange}>
                Change Password
              </button>

              <Divider sx={{ my: 3 }} />

              <h3>Forgot Password?</h3>
              <button
                className="change-pass-btn"
                style={{ backgroundColor: "#f44336" }}
                onClick={handleResetPassword}
              >
                Reset Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
